import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

export const appointmentsTableColumns = [
  createColumn({
    keyName: "title",
    header: () => i18next.t("appointments_columns_title"),
    cell: (info) => info.renderValue(),
    size: 300,
  }),
  createColumn({
    keyName: "date",
    header: () => i18next.t("appointments_columns_time"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "duration",
    header: () => i18next.t("appointments_columns_duration"),
    cell: (info) => info.renderValue(),
    size: 100,
  }),
  createColumn({
    keyName: "createdBy",
    header: () => i18next.t("appointments_columns_createdBy"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "appointmentStatus",
    header: () => "",
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "deleteAppointment",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 30,
  }),
];
